import { Box, Chip, Grid, Typography } from '@mui/material';
import { formatPriceByLocale } from '../../lib/utils';

type Rate = {
    name?: string;
    duration?: number;
    price?: number;
    priceShape?: {
        currency?: string | null;
        locale?: string;
    };
};

type Props = {
    rates: Rate[];
    title?: string;
    color?:
        | 'default'
        | 'primary'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning';
    maxWidth?: string | number;
    grid?: boolean;
    xs?: number;
    justifyContent?: string;
    [key: string]: unknown;
};

export function SttChipRate({
    rates,
    title = '',
    color = 'primary',
    maxWidth = 'auto',
    grid = false,
    xs = 12,
    justifyContent = 'left',
    ...rest
}: Props): React.ReactElement {
    function unifyRate(rate: Rate): string {
        const name = rate.name ? rate.name : '';
        const duration = rate.duration ? `${rate.duration} min` : '';
        const price = rate.price
            ? formatPriceByLocale(
                  rate.price,
                  rate?.priceShape?.currency ?? undefined,
                  rate?.priceShape?.locale,
              )
            : '';
        return `${name} ${duration} ${price}`;
    }

    const content = (
        <>
            {title !== '' && <Typography variant="caption">{title}</Typography>}
            <Box
                display="flex"
                maxWidth={maxWidth}
                flexWrap="wrap"
                justifyContent={justifyContent}
                alignItems="center"
            >
                {rates &&
                    rates.map((rate: any, idx: any) => (
                        <Box key={idx} mr={1}>
                            <Chip
                                color={color}
                                size="small"
                                label={unifyRate(rate)}
                            />
                        </Box>
                    ))}
            </Box>
        </>
    );

    // -----| Render |-----
    return grid ? (
        <Grid {...rest} size={{ xs }}>
            {content}
        </Grid>
    ) : (
        content
    );
}
